import { render, staticRenderFns } from "./5_Resumen.vue?vue&type=template&id=1f5d3246&scoped=true"
import script from "./5_Resumen.vue?vue&type=script&lang=ts"
export * from "./5_Resumen.vue?vue&type=script&lang=ts"
import style0 from "./5_Resumen.vue?vue&type=style&index=0&id=1f5d3246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d3246",
  null
  
)

export default component.exports